import { message } from 'antd';
import axios from 'axios';
import { tomcatHost, cloudFrontCdnUrl } from '../config/properties';
import { getAuthToken } from '../utils/authUtils';


import { solicitationStatus } from '../pages/SolicitationDetail/graphql';
// src\pages\SolicitationDetail\graphql.js

export async function downloadFile(url, fileExtension, fileName, jwtToken, callbackFunction = null) {
    let fileType
    switch (fileExtension) {
        case 'csv':
            fileType = "text/csv"
            break;
        case 'pdf':
            fileType = "application/pdf";
            break;
        default:
            break;
    }

    // Workaround for CloudFront CORS issue: use direct backend URL for downloads
    let directUrl = url;
    if (url.includes('cloudfront.net')) {
        // Extract the backend URL from the CloudFront URL
        const urlParts = url.split('/');
        const backendIndex = urlParts.findIndex(part => part.includes('services.'));
        if (backendIndex !== -1) {
            directUrl = `https://${urlParts[backendIndex]}/${urlParts.slice(backendIndex + 1).join('/')}`;
        }
        console.log('CloudFront CORS workaround - Original URL:', url);
        console.log('CloudFront CORS workaround - Direct URL:', directUrl);
    }

    const config = {
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    }

    try {
        const res = await axios.get(directUrl, config);

        // Check if response is successful and has data
        if (res.status === 200 && res.data) {
            console.log("FILE FOUND");
            if (callbackFunction) callbackFunction(false);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([res.data], { type: fileType }));
            link.setAttribute('download', `${fileName}.${fileExtension}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.log("FILE NOT FOUND");
            message.error('File not found or empty response', 3);
            if (callbackFunction) callbackFunction(false);
        }
    } catch (error) {
        console.error('Download error:', error);
        if (error.response && error.response.status === 404) {
            message.error('File not found. Please check if the data exists.', 3);
        } else if (error.response && error.response.status === 403) {
            message.error('Access denied. Please check your permissions.', 3);
        } else {
            message.error('Failed to download file. Please try again.', 3);
        }
        if (callbackFunction) callbackFunction(false);
    }
}


export async function getSolicitationInfoPdf(solNum) {
    let solStatus = '';
    await solicitationStatus(solNum)
        .then(res => {
            solStatus = res.solicitationStatus.status;
        })
        .catch(error => {
            console.log(error);
        });

    const jwtToken = getAuthToken();
    const config = {
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        }
    }

    axios.get(`${cloudFrontCdnUrl}/${tomcatHost}/solicitations/pdf/solnum/${solNum}`, config)
        .then(res => {
            // Check if response is a valid PDF blob
            const isPdfBlob = res.data instanceof Blob && res.data.type === "application/pdf";
            const isPdfSize = res.data instanceof Blob && res.data.size > 0;
            
            if (isPdfBlob && isPdfSize) {
                console.log(`FOUND PDF INFO FOR SOLICITATION ${solNum}`);
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `solicitation-${solNum}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                // PDF not found - redirect to DIBBS
                console.log(`PDF for solicitation # ${solNum} was not found!`);
                if (solStatus !== "Closed") {
                    // message pop up disabled related to NFFS-1660
                    // message.warning(`PDF for solicitation # ${solNum} was not found. Opening DIBBS website...`, 3);
                    window.open(`https://www.dibbs.bsm.dla.mil/rfq/rfqrec.aspx?sn=${solNum}`, '_blank');
                } else {
                    message.warning(`PDF for solicitation # ${solNum} was not found.`, 3);
                }
            }
        })
        .catch(error => {
            console.error(`Error retrieving PDF for solicitation # ${solNum}:`, error);
            // If PDF is not found (404 or other error), redirect to DIBBS
            if (solStatus !== "Closed") {
                message.warning(`PDF for solicitation # ${solNum} was not found. Opening DIBBS website...`, 3);
                window.open(`https://www.dibbs.bsm.dla.mil/rfq/rfqrec.aspx?sn=${solNum}`, '_blank');
            } else {
                message.error(`PDF for solicitation # ${solNum} was not found.`, 3);
            }
        });
}


// WEBPACK FOOTER //
// ./src/utils/fileDownload.js